function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesBathTowelFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6c-1.1 0-2 .9-2 2v14h9v2H8v1c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2V8c0-.63.28-1.38.73-2H10zm11.42 1.07c.25-.31.56-.51.91-.56.41.37.66.9.66 1.49h-2c0-.14.11-.54.42-.93h.01zM30 8h-5c0-2.21-1.79-4-4-4H10C7.79 4 6 5.79 6 8H2v2h4v15c0 2.21 1.79 4 4 4h7c2.21 0 4-1.79 4-4V10h2v11c0 .55-.45 1-1 1v2c1.66 0 3-1.34 3-3V10h5V8z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesBathTowelFilled;